<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Pays"><app-country-list></app-country-list></mat-tab>
  <mat-tab label="Villes"><app-city-list></app-city-list></mat-tab>
  <mat-tab label="Aéroports"><app-airport-list></app-airport-list></mat-tab>
  <mat-tab label="Compagnies aériennes"><app-airline-list></app-airline-list></mat-tab>
</mat-tab-group>